import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { getCategory, sortByPopularity } from "@/utils/manga";
import MangaCard from "@/components/feature/MangaCard";
import SectionTitle from "@/components/feature/SectionTitle";

export default function Completed() {
  const completed = mangaList
    .filter((m) => m.status === "已完结")
    .sort((a, b) => b.rating - a.rating);
  const total = mangaList.filter((m) => m.status === "已完结").length;
  const top4 = completed.slice(0, 4);

  return (
    <section className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="追更无压力"
          title="完结作品"
          subtitle="经典完结佳作一次看到底，不用担心追更断更，尽情享受完整剧情。"
          to="/completed"
          moreLabel="全部完结"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="relative overflow-hidden rounded-lg bg-foreground-900 lg:col-span-1">
            <img
              src="https://readdy.ai/api/search-image?query=collection%20of%20stacked%20finished%20manga%20volumes%20with%20warm%20reading%20lamp%20light%20and%20golden%20sparkles%2C%20warm%20coral%20and%20amber%20palette%2C%20cozy%20nostalgic%20manga%20atmosphere%2C%20high%20detail%20illustration&width=900&height=1000&seq=home-completed-banner&orientation=portrait"
              alt="完结漫画合集"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-foreground-950/20"></div>
            <div className="relative flex h-full flex-col justify-end p-6 md:p-8">
              <p className="font-heading text-5xl text-secondary-300">{total}+</p>
              <h3 className="mt-1 font-heading text-2xl text-background-50">部完结佳作等你回味</h3>
              <p className="mt-2 max-w-xs text-sm text-background-50/85">
                一次性看完完整剧情，经典高分完结作品免费抢先体验。
              </p>
              <Link
                to="/completed"
                className="mt-5 inline-flex w-max items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                浏览完结专区 <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4 lg:col-span-2">
            {top4.map((m) => (
              <MangaCard key={m.id} manga={m} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}